import { createSelector } from 'reselect'

// SELECTORS //
export const selectSearchConfig = (state) => state.search.config
export const selectSearchProperty = (state) => state.search.property
export const selectIntegratorShortName = (state) => state.search.integratorShortName

// RE-SELECTORS //
export const getHeaderSelector = createSelector(
  [selectSearchConfig],
  ({ preferences }) => ({
    backgroundColor: preferences.headerBackgroundColor,
    companyLogoUrl: preferences.companyLogoUrl,
    logoUrl: preferences.headerLogoUrl,
    link: preferences.linkThroughUrl,
    primaryColor: preferences.primaryColor
  })
)

export const getBodySelector = createSelector(
  [selectSearchConfig],
  ({ integratorId, gtmContainerId, preferences, title, textBelowTitle }) => ({
    acceptCookieButtonStyles: preferences.acceptCookieButtonStyles,
    backgroundColor: preferences.bodyBackgroundColor,
    backgroundImgUrlDesktop: preferences.heroImageUrlDesktop,
    backgroundImgUrlMobile: preferences.heroImageUrlMobile,
    belowTitle: textBelowTitle,
    integratorId,
    title,
    homePageFontColor: preferences.homePageFontColor,
    homePageShadowForHeroText: preferences.homePageShadowForHeroText,
    homePageShadowXValue: preferences.homePageShadowXValue,
    homePageShadowYValue: preferences.homePageShadowYValue,
    gtmContainerId,
    searchButtonStyles: preferences.searchButtonStyles
  })
)

export const getFooterSelector = createSelector(
  [selectSearchConfig],
  ({ preferences, homePageDisclaimer }) => ({
    backgroundColor: preferences.footerBackgroundColor,
    disclaimer: homePageDisclaimer,
    color: preferences.reportFooterFontColor
  })
)

export const getConfigSelector = createSelector(
  [getHeaderSelector, getBodySelector, getFooterSelector],
  (header, body, footer) => ({
    header,
    body,
    footer
  })
)
